import {BeforeYouthPlayerRecruitmentEvent} from "@/modules/youth/event/BeforeYouthPlayerRecruitmentEvent";

export class AfterYouthPlayerRecruitmentEvent extends BeforeYouthPlayerRecruitmentEvent {
}